import script from "./domain-category-picker.vue?vue&type=script&setup=true&lang=ts"
export * from "./domain-category-picker.vue?vue&type=script&setup=true&lang=ts"

import "./domain-category-picker.vue?vue&type=style&index=0&id=16c43937&lang=scss&scoped=true"
import "./domain-category-picker.vue?vue&type=style&index=1&id=16c43937&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c43937"]])

export default __exports__